import gsap from 'gsap'
import { createTextSprite } from './InteractionTile.js'

export default class OssuaryView
{
    constructor(_options)
    {
        this.ossuary = _options.ossuary
        this.factory = _options.factory
        this.container = this.factory.createOssuary()
        this.container.position.set(this.ossuary.x, this.ossuary.y, 0)
        this.container.visible = this.ossuary.revealed
        this.lastStackKey = ''
        const label = createTextSprite('OSSUARY  •  TAP TO TRANSFER', { background: 'rgba(20, 15, 31, 0.88)', color: '#c8ffdb' })
        label.position.set(0, 0, 3.1)
        label.scale.set(3.8, 0.72, 1)
        this.container.add(label)
        this.sync()
    }

    reveal()
    {
        this.container.visible = true
        this.container.scale.setScalar(0.01)
        gsap.to(this.container.scale, { x: 1, y: 1, z: 1, duration: 0.65, ease: 'back.out(1.7)' })
    }

    sync()
    {
        const key = JSON.stringify(this.ossuary.stored)
        if(key === this.lastStackKey)
            return
        this.lastStackKey = key
        const contents = this.container.userData.contents
        for(const child of [...contents.children])
        {
            child.traverse((_child) =>
            {
                if(_child.isMesh)
                    _child.geometry.dispose()
            })
            contents.remove(child)
        }
        const items = Object.entries(this.ossuary.stored)
            .flatMap(([resource, count]) => Array.from({ length: Math.min(count, 27) }, () => resource))
            .slice(0, 27)
        items.forEach((_resource, _index) =>
        {
            const item = this.factory.createItem(_resource, 0.85)
            item.position.set((_index % 3 - 1) * 0.42, (Math.floor(_index / 3) % 3 - 1) * 0.36, Math.floor(_index / 9) * 0.25)
            contents.add(item)
        })
    }
}
